import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

const Forgot = (props) => {
  const { pathname } = window.location;
  return (
    <div className="Forgot">
      <h1>Forgot your Password<span>?</span></h1>
      <p>
        Please enter the email address you used to register for TheSOURCE, and we’ll send you an email to reset your password.
      </p>
      <input
        type="email"
        name="email"
        defaultValue={props.defaultVal}
        onChange={props.change}
        placeholder="Email"
      />
      <div className="buttonWrapper">
        {pathname === '/login/forgot-mobile' ? (
          <button type="button" onClick={() => window.ReactNativeWebView.postMessage('exit')} className="white">{i18n.translate('general.back')}</button>
        ) : (
          <Link to="/login">
            <button type="button" onClick={props.back} className="white">{i18n.translate('general.back')}</button>
          </Link>
        )}
        <button type="submit" onClick={props.submit}>
          {props.loadingAnimRegister ? <span><FontAwesomeIcon icon={['fas', 'circle-notch']} spin /></span> : 'Submit'}
        </button>
      </div>
    </div>
  );
};

export default Forgot;

Forgot.propTypes = {
  defaultVal: PropTypes.string,
  change: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
};

Forgot.defaultProps = {
  defaultVal: '',
};
